import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';

// Page imports
import HomePage from './pages/Home';
import ArchitecturePage from './pages/Architecture';
import CapabilitiesPage from './pages/Capabilities';
import CentreOfExcellencePage from './pages/CentreOfExcellence';
import ContactPage from './pages/Contact';
import EngagementModelsPage from './pages/EngagementModels';
import InsightsPage from './pages/Insights';
import RoiPage from './pages/Roi';
import TcoPage from './pages/Tco';
import TechnologyStackPage from './pages/TechnologyStack';
import GovernmentIndustryPage from './pages/industries/Government';
import BfsiIndustryPage from './pages/industries/Bfsi';
import DigitalNativeIndustryPage from './pages/industries/DigitalNative';
import DefenceIndustryPage from './pages/industries/Defence';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';

import './app/globals.css';

export default function App() {
  return (
    <BrowserRouter>
      <div className="min-h-dvh bg-atmosphere" style={{ background: "var(--gradient-hero)" }}>
        <SiteHeader />
        <main className="relative z-10 pt-28">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/architecture" element={<ArchitecturePage />} />
            <Route path="/capabilities" element={<CapabilitiesPage />} />
            <Route path="/centre-of-excellence" element={<CentreOfExcellencePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/engagement-models" element={<EngagementModelsPage />} />
            <Route path="/insights" element={<InsightsPage />} />
            <Route path="/roi" element={<RoiPage />} />
            <Route path="/tco" element={<TcoPage />} />
            <Route path="/technology-stack" element={<TechnologyStackPage />} />
            <Route path="/industries/government" element={<GovernmentIndustryPage />} />
            <Route path="/industries/bfsi" element={<BfsiIndustryPage />} />
            <Route path="/industries/digital-native" element={<DigitalNativeIndustryPage />} />
            <Route path="/industries/defence" element={<DefenceIndustryPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
          </Routes>
          <SiteFooter />
        </main>
      </div>
    </BrowserRouter>
  );
}
